import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { useLang } from "../lib/i18n";
import { LangToggle } from "../components/LangToggle";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message); setSent(true);
    } catch (err) { setMsg(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-white px-6 pt-6">
      <div className="flex items-center justify-between"><Link to="/login" className="text-slate-500"><ArrowLeft /></Link><LangToggle /></div>
      <h1 className="mt-10 font-display text-3xl font-extrabold text-slate-900">{t("forgot_password")}</h1>
      {sent ? (
        <div data-testid="forgot-sent" className="mt-8 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
          <MailCheck className="mb-2 h-6 w-6" />{msg}
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="forgot-email" type="email" required placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none focus:border-blue-500 focus:bg-white" />
          <button data-testid="forgot-submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 py-3 font-bold text-white transition hover:bg-blue-700 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}{t("send_reset")}
          </button>
        </form>
      )}
      <Link to="/login" className="mt-6 text-center text-sm font-semibold text-blue-600">{t("back_to_login")}</Link>
    </div>
  );
}
